import React from "react";
import Backdrop from "@mui/material/Backdrop";
import Card from "@mui/material/Card";
import CardMedia from "@mui/material/CardMedia";
import CardContent from "@mui/material/CardContent";
import classNames from "classnames";
import Text from "../text/Text";
import { speedPreloader } from "../images";

const BackdropLoader = ({ open, text, alt, customClass }) => {
  const classes = classNames("backdrop-loader", customClass);

  return (
    <Backdrop className={classes} open={open}>
      <Card>
        <CardMedia component="img" image={speedPreloader} alt={alt} />
      </Card>
    </Backdrop>
  );
};

export default BackdropLoader;
